"use client";
import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { memo as c } from "react";
import { Box as a } from "../base/Base.js";
import '../../assets/Features.css';const n = "_set_1g9xg_1", i = "_feature_1g9xg_18", l = "_icon_1g9xg_29", m = "_text_box_1g9xg_37", g = "_title_1g9xg_42", p = "_text_1g9xg_37", t = {
  set: n,
  feature: i,
  icon: l,
  text_box: m,
  title: g,
  text: p
}, u = c(({ children: s }) => /* @__PURE__ */ e(a, { gap: 12, row: !0, className: t.set, children: s }));
u.displayName = "FeaturesSet";
const N = c(
  ({ icon: s, title: r, text: x, ..._ }) => /* @__PURE__ */ o(a, { gap: 16, className: t.feature, ..._, children: [
    /* @__PURE__ */ e("span", { className: t.icon, children: s }),
    /* @__PURE__ */ o(a, { gap: 12, className: t.text_box, children: [
      /* @__PURE__ */ e("span", { className: t.title, children: r }),
      /* @__PURE__ */ e("span", { className: t.text, children: x })
    ] })
  ] })
);
N.displayName = "Feature";
export {
  N as Feature,
  u as FeaturesSet
};
